import React from 'react';
import { Tooltip } from 'react-bootstrap';

function tooltipRenderer(id, roles) {
    return (
        <Tooltip id={id} placement="top">
            <div>
                {roles.length ? (
                    <ul style={{ padding: '0.625rem 0.625rem 0.5rem 1.25rem', textAlign: 'left' }}>
                        {roles.map((role) => {
                            return <li key={role.roleId}>{role.roleName}</li>;
                        })}
                    </ul>
                ) : (
                    'No Roles'
                )}
            </div>
        </Tooltip>
    );
}

export default tooltipRenderer;
